import _ from 'lodash'
import { Palette } from 'lucide-react'
import { ProviderContentCard } from '@/components/casino/lobby/ProviderCard'
import { ProviderCardSkeleton } from '@/components/casino/lobby/ProviderCardSkeleton'
import { CASINO_PROVIDERS_PER_PAGE } from '@/config/casino'
import { useGetCasinoProvidersQuery } from '@/store/api/casinoApi'

export function CasinoProvidersContent() {
	const { data, isLoading, isError } = useGetCasinoProvidersQuery({
		page: 1,
		per_page: CASINO_PROVIDERS_PER_PAGE,
	})

	const providers = data?.data ?? []

	return (
		<section className='flex flex-col gap-4'>
			<div className='flex items-center gap-3'>
				<Palette className='h-7 w-7 text-subtle-foreground' />
				<h2 className='text-2xl font-semibold tracking-[-0.12px] text-foreground'>Providers</h2>
			</div>

			{isError ? <p className='text-sm text-muted-foreground'>Unable to load game providers right now.</p> : null}

			{isLoading ? (
				<div className='grid grid-cols-2 gap-4 overflow-visible pb-8 pt-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6'>
					{_.times(12, (index) => (
						<ProviderCardSkeleton key={`provider-grid-skeleton-${index}`} variant='content' className='w-full min-w-0' />
					))}
				</div>
			) : null}

			{!isLoading && !isError && _.isEmpty(providers) ? <p className='text-sm text-muted-foreground'>No game providers are available right now.</p> : null}

			{!isLoading && !isError && !_.isEmpty(providers) ? (
				<div className='grid grid-cols-2 gap-4 overflow-visible pb-8 pt-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6'>
					{_.map(providers, (provider) => (
						<ProviderContentCard key={provider.id} provider={provider} className='w-full min-w-0' />
					))}
				</div>
			) : null}
		</section>
	)
}
